export default __webpack_public_path__ + "static/media/1925.66199b07.png";